const _excluded = ["steps", "as"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useGlobalContext } from 'seagull';
import React from 'react';
import { Button, TextButton } from 'seagull';
import Modal from "./Modal";
export default function SeeWhatItsLike(_ref) {
  let {
    steps,
    as = 'button'
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const globalContext = useGlobalContext();
  const tid = props['data-testid'];
  const testPrefix = "".concat(tid ? tid + '-' : '', "see-what-it-is-like");

  const handleOnClick = () => {
    return globalContext.showModal({
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/React.createElement(Modal, {
          steps: steps,
          onClose: dismissModal,
          testPrefix: testPrefix
        });
      },
      closeOnClickOutside: true,
      closeOnEscapeKey: true
    });
  };

  if (as === 'button') {
    return /*#__PURE__*/React.createElement(Button, _extends({
      skin: "primaryOutline"
    }, props, {
      "data-testid": testPrefix,
      onClick: handleOnClick
    }), "See what it\u2019s like");
  } else {
    return /*#__PURE__*/React.createElement(TextButton, _extends({}, props, {
      "data-testid": testPrefix,
      onClick: handleOnClick
    }), "See what it\u2019s like");
  }
}